// DetailsModal.js
import moment from "moment";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Modal from "react-modal";
import HttpClient from "../../utils/HttpClient";
import { jwtDecode } from "jwt-decode";

Modal.setAppElement("#root"); // Set the root element for accessibility

const format1 = "DD-MM-YYYY, h:mm a";

const OfferModal = ({ isOpen, closeModal, id }) => {
  const [tableData, setTableData] = useState([]);


  // fetch Category DAta
  const getOfferSingleData = async () => {
    // setIsLoading(true);

    const res = await HttpClient.requestData("offer/" + id, "GET", {});
    if (res && res?.status) {
      setTableData(res?.data);
    }
  };
  useEffect(() => {
    getOfferSingleData();
  }, [id]);
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Details Modal"
      className=""
    >
      <a href="#" className="mtclose" onClick={closeModal}>
        <i className="fa-solid fa-xmark"></i>
      </a>

      <>
        <div className=" container">
          <div className=" row ">
            <div className="col-12 d-flex justify-content-center ">
              <h2 className="  border-bottom border-danger mb-3">
                User Details
              </h2>
            </div>
            <hr />
            <div className="col-12 d-flex mt-3">
              <h4 className="item-description col-4">Date & Time Created :</h4>
              &nbsp;&nbsp;&nbsp;
              <p className="mt-1">
                {moment(tableData?.[0]?.createdOn).format(format1)}
              </p>
            </div>
            <div className="col-12 d-flex mt-3">
              <h4 className="item-description col-4">Expiry Date & Time :</h4>
              &nbsp;&nbsp;&nbsp;
              <p className="mt-1">
                {moment(tableData?.[0]?.offerExpiryDate).format(format1)}
              </p>
            </div>
            <div className="col-12 d-flex mt-3">
              <h4 className="item-description col-4">Partner Name :</h4>
              &nbsp;&nbsp;&nbsp;
              <p className="mt-1">{tableData?.[0]?.partnerName}</p>
            </div>
            <div className="col-12 d-flex mt-3">
              <h4 className="item-description col-4">Partner Logo</h4>
              &nbsp;&nbsp;&nbsp;
              <img src={tableData?.[0]?.partnerLogo} alt="" id='preview' height="100px" width="100px"/>
            </div>
            <div className="col-12 d-flex mt-3">
              <h4 className="item-description col-4">Offer Cover Image :</h4>
              &nbsp;&nbsp;&nbsp;
              <img src={tableData?.[0]?.offerCoverImage} alt="" id='preview' height="100px" width="100px"/>
            </div>
            <div className="col-12 d-flex mt-3">
              <h4 className="item-description col-4">offerType :</h4>
              &nbsp;&nbsp;&nbsp;
              <p className="mt-1">{tableData?.[0]?.offerType}</p>
            </div>
            <div className="col-12 d-flex mt-3">
              <h4 className="item-description col-4">description :</h4>
              &nbsp;&nbsp;&nbsp;
              <p className="mt-1">{tableData?.[0]?.description}</p>
            </div>
            <div className="col-12 d-flex mt-3">
              <h4 className="item-description col-4">reddemingPoints :</h4>
              &nbsp;&nbsp;&nbsp;
              <p className="mt-1">{tableData?.[0]?.reddemingPoints}</p>
            </div>
            {/* <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Service Type :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.service.map((item, i) => { return (<>&nbsp;<span key={i}>{item}</span>&nbsp;,</>) })}</p>
                        </div> */}
            <div className="col-12 d-flex mt-3">
              <h4 className="item-description col-4">voucherNo :</h4>
              &nbsp;&nbsp;&nbsp;
              <p className="mt-1">{tableData?.[0]?.voucherNo}</p>
            </div>

            {/* <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Telephone :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'><i className="fa-solid fa-phone"></i> - {tableData?.[0]?.telephoneNo}</p>
                        </div> */}
            <div className="col-12 d-flex mt-3">
              <h4 className="item-description col-4">Voucher Description :</h4>
              &nbsp;&nbsp;&nbsp;
              <p className="mt-1">{tableData?.[0]?.voucherDesc}</p>
            </div>
            <div className="col-12 d-flex mt-3">
              <h4 className="item-description col-4">voucherValidity :</h4>
              &nbsp;&nbsp;&nbsp;
              <p className="mt-1">{tableData?.[0]?.voucherValidity}</p>
            </div>
            <div className="col-12 d-flex mt-3">
              <h4 className="item-description col-4">offerValidity :</h4>
              &nbsp;&nbsp;&nbsp;
              <p className="mt-1">{tableData?.[0]?.offerValidity}</p>
            </div>
            <div className="col-12 d-flex mt-3">
              <h4 className="item-description col-4">howToGetOffer :</h4>
              &nbsp;&nbsp;&nbsp;
              <p className="mt-1">{tableData?.[0]?.howToGetOffer}</p>
            </div>
            <div className="col-12 d-flex mt-3">
              <h4 className="item-description col-4">offerTermsCondition :</h4>
              &nbsp;&nbsp;&nbsp;
              <p className="mt-1">{tableData?.[0]?.offerTermsCondition}</p>
            </div>
            <div className="col-12 d-flex mt-3">
              <h4 className="item-description col-4">profileLink :</h4>
              &nbsp;&nbsp;&nbsp;
              <p className="mt-1">{tableData?.[0]?.profileLink}</p>
            </div>

            {/* <div className='col-12 d-flex mt-3 '>
                            <h4 className='item-description col-4'>Website :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'><a href={tableData?.[0]?.websiteLink} style={{ textDecoration: "underline", cursor: "pointer" }}>{tableData?.[0]?.websiteLink}</a></p>
                        </div> */}
            {/* <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Address :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.address} , ({tableData?.[0]?.location})</p>
                        </div> */}
            {/* <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Profile Name :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.userName}</p>
                        </div> */}

            {/* <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4 mt-5'>Banner :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <img src={tableData?.[0]?.banner} alt="" id='preview' height="150px" width="150px" />

                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4 mt-5'>Profile Photo :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <img src={tableData?.[0]?.profilePhoto} alt="" id='preview' height="150px" width="150px" />

                        </div> */}
          </div>
        </div>
      </>
    </Modal>
  );
};

export default OfferModal;
